import apiUrls from '../urls';

export default function (api) {
    return {
        getRules() {
            return api.get(apiUrls.RULES);
        },
    }
};